import axios from "axios";
import {
  PAYMENT_INFO_REQUEST,
  PAYMENT_INFO_SUCCESS,
  PAYMENT_INFO_FAIL,
  EDIT_PAYMENT_INFO_REQUEST,
  EDIT_PAYMENT_INFO_SUCCESS,
  EDIT_PAYMENT_INFO_FAIL,
} from "constants/infoConstants";
import InfoService from "services/info-service";

export const getPaymentInfo = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: PAYMENT_INFO_REQUEST,
    });

    const res = await InfoService.getPaymentInfo();
    console.log(
      "🚀 ~ file: transactionActions.js:55 ~ getPaymentInfo ~ res:",
      res
    );

    dispatch({
      type: PAYMENT_INFO_SUCCESS,
      payload: res.foundInfo,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: transactionActions.js:61 ~ getPaymentInfo ~ error:",
      error
    );
    dispatch({
      type: PAYMENT_INFO_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const paymentInfoUpdate =
  (infoId, info) => async (dispatch, getState) => {
    try {
      dispatch({
        type: EDIT_PAYMENT_INFO_REQUEST,
      });

      const res = await InfoService.editPaymentInfo(infoId, info);
      console.log("🚀 ~ file: infoActions.js:78 ~ res:", res);

      dispatch(getPaymentInfo());

      dispatch({
        type: EDIT_PAYMENT_INFO_SUCCESS,
        payload: res,
      });
    } catch (error) {
      console.log("🚀 ~ file: infoActions.js:86 ~ error:", error);
      dispatch({
        type: EDIT_PAYMENT_INFO_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };
